import React from 'react';
import Box from '@mui/material/Box';
import { func, number } from 'prop-types';
import { useUserRolePermissions } from 'hooks';
import Button from '@mui/material/Button';

const Footer = ({ carrierAuthorizationId, onEdit, onRemove }) => {
  const { isProductLoadingManage, isSupplier } = useUserRolePermissions();
  return (
    <Box display="flex" justifyContent="space-around" mt={1}>
      {isProductLoadingManage && isSupplier && (
        <Button onClick={() => onRemove(carrierAuthorizationId)} variant="outlined">
          Remove
        </Button>
      )}
      {isProductLoadingManage && (
        <Button onClick={() => onEdit(carrierAuthorizationId)}>Edit</Button>
      )}
    </Box>
  );
};

Footer.propTypes = {
  carrierAuthorizationId: number,
  onEdit: func.isRequired,
  onRemove: func.isRequired,
};

Footer.defaultProps = {
  carrierAuthorizationId: undefined,
};

export default Footer;
